// Resumo e movimentos de um caixa já fechado, para o painel do fechamento
// (25/10/2026). Busca de novo a cada caixa aberto no painel; resposta de um
// caixa anterior que chega atrasada é descartada.

import { useEffect, useState } from "react";

import { caixaApi } from "../api/caixaApi";

export function useDetalheCaixa(caixa) {
  const [dados, setDados] = useState({ resumo: null, movimentos: [], carregando: false, erro: false });

  useEffect(() => {
    if (!caixa?.id) return undefined;
    let vivo = true;
    setDados({ resumo: null, movimentos: [], carregando: true, erro: false });
    Promise.all([caixaApi.obterResumo(caixa.id), caixaApi.listarMovimentos(caixa.id)])
      .then(([resumo, movimentos]) => { if (vivo) setDados({ resumo, movimentos, carregando: false, erro: false }); })
      .catch(() => { if (vivo) setDados({ resumo: null, movimentos: [], carregando: false, erro: true }); });
    return () => { vivo = false; };
  }, [caixa?.id]);

  return dados;
}
